<template>
  <BreadCrumb PageTitle="Timepicker" />
  <TimepickerContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import TimepickerContent from "../../template-components/UIElements/Timepicker/TimepickerContent.vue";

export default defineComponent({
  name: "TimepickerPage",
  components: {
    BreadCrumb,
    TimepickerContent,
  },
});
</script>